import { render, staticRenderFns } from "./ClientRequestsHome.vue?vue&type=template&id=0762e836&scoped=true"
import script from "./ClientRequestsHome.vue?vue&type=script&lang=js"
export * from "./ClientRequestsHome.vue?vue&type=script&lang=js"
import style0 from "./ClientRequestsHome.vue?vue&type=style&index=0&id=0762e836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0762e836",
  null
  
)

export default component.exports